import { screen } from "@testing-library/react";
import CatalogGroup from "../../../lib/Models/Catalog/CatalogGroup";
import Terria from "../../../lib/Models/Terria";
import ViewState from "../../../lib/ReactViewModels/ViewState";
import Breadcrumbs from "../../../lib/ReactViews/Search/Breadcrumbs";
import { renderWithContexts } from "../withContext";
import { jsx as _jsx } from "react/jsx-runtime";
describe("Breadcrumbs", function () {
  let terria;
  let viewState;
  let catalogGroup;
  beforeEach(function () {
    terria = new Terria({
      baseUrl: "./"
    });
    viewState = new ViewState({
      terria: terria,
      catalogSearchProvider: undefined
    });
    catalogGroup = new CatalogGroup("group-of-geospatial-cats", terria);
    terria.addModel(catalogGroup);
  });
  describe("with a previewed catalog item", function () {
    it("renders", async function () {
      var _container$querySelec;
      const {
        container
      } = renderWithContexts(/*#__PURE__*/_jsx(Breadcrumbs, {
        previewed: catalogGroup
      }), viewState);

      // Breadcrumbs renders with a globe icon SVG
      expect(screen.getByText("group-of-geospatial-cats")).toBeVisible();
      expect((_container$querySelec = container.querySelector("svg")) === null || _container$querySelec === void 0 || (_container$querySelec = _container$querySelec.querySelector("use")) === null || _container$querySelec === void 0 ? void 0 : _container$querySelec.getAttribute("xlink:href")).toBe("#terriajs-globe");
    });
  });
});